import './index.styles.css'
interface Props {
  selected: boolean
}

// FIXME: The Radio components we have in the Default Shift lists are not quite
// adaptable from the DS Radio component. We are using our own radio button (the small
// circle at the top right) for now. I know it's not ideal but we don't have the capacity
// to develop our own Radio component with all it's requirements right now.
const UnsafeRadioInput = ({ selected }: Props) => {
  const variant = selected ? 'selected' : 'unselected'
  return <div className={`UnsafeRadioInput_checkbox_${variant}`}></div>
}

export default UnsafeRadioInput
